export default "<p>addons works!</p>\r\n";